import React, { useState, useContext } from 'react'

// import defaultUserImg from 'src/images/defaultUser.png'
import AddComment from './AddComment'
import { CommentsContext, getReplyCount } from './util'

const Comment = ({ comment, level }) => {
  const { id, user, comment: content } = comment || {};;

  const [isTextOpen, setIsTextOpen] = useState(false);
  const context = useContext(CommentsContext);
  const { comments, readOnly } = context;

  const replyCount = getReplyCount(comments, comment.id);

  // const onLike = () => {
  //   console.log('Like', id)
  // }
  // const onDislike = () => {
  //   console.log('Dislike', id)
  // }
  const onReply = () => {
    console.log('Reply', id);
    setIsTextOpen(!isTextOpen);
  };

  const interactions = [
    // {
    //   id: 'like',
    //   func: readOnly ? () => {} : onLike,
    //   value: 0,
    //   icon: 'thumb_up',
    // },
    // {
    //   id: 'dislike',
    //   func: readOnly ? () => {} : onDislike,
    //   value: 0,
    //   icon: 'thumb_down',
    // },
  ];

  if (level < 3) {
    interactions.push({
      id: 'reply',
      func: readOnly ? () => {} : onReply,
      value: replyCount,
      icon: 'chat_bubble',
    });
  }

  return (
    <div>
      <div className="comment-container">
        {/* <Avatar user={user} /> */}
        <div className="user-name">
          {(user && user.display_name) || 'Anonymous'}
          {/* <div className="more">
            <span className="material-icons">more_horiz</span>
          </div> */}
        </div>
        <div className="comment">{content}</div>
        {!readOnly && (
          <div className="bottom_row">
            <div className={`comment_buttons ${readOnly && 'readOnly'}`}>
              {interactions.map(({ func, value, icon }) => (
                <Stat key={icon} onClick={func} icon={icon} value={value} />
              ))}
            </div>
          </div>
        )}
      </div>
      {isTextOpen && (
        <AddComment parentId={id} closeText={() => setIsTextOpen(false)} />
      )}
    </div>
  );
}

const Stat = ({ icon, value, onClick = () => {} }) => {
  return (
    <div onClick={onClick} className="comment_stat">
      <span>{value}</span>
      <div className="comment_stat-icon">
        <i className="material-icons">{icon}</i>
      </div>
    </div>
  )
}

// const Avatar = ({ user }) => {
//   const hasAuthor = user && user.initials
//   const containerClassName = hasAuthor ? 'avatar filled' : 'avatar'

//   return (
//     <div className={containerClassName}>
//       {hasAuthor ? (
//         <span className="initials">{user.initials}</span>
//       ) : (
//         <img className="initials" src={defaultUserImg} alt="default_user" />
//       )}
//     </div>
//   )
// }

export default Comment
